
export enum ResponseCode {
  BAD_REQUEST = 400,
  OK = 200,
};
